import { useEffect, useState } from 'react'

import {
  EXTEND_ID,
  EXTEND_ENVIRONMENT,
} from '@/services/Configuration'

export const useIsExtendScriptLoaded = () => {
  const [addonLoaded, setAddonLoaded] = useState(false)
  const [clientLoaded, setClientLoaded] = useState(false)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (window.Extend) {
      setClientLoaded(true)
      return () => {}
    }

    const clientLoadedSetter = () => setClientLoaded(true)
    document.addEventListener('ExtendClientLoaded', clientLoadedSetter)

    return () => document.removeEventListener('ExtendClientLoaded', clientLoadedSetter)
  }, [])

  useEffect(() => {
    if (window.ExtendBigCommerce) {
      setAddonLoaded(true)
      return () => {}
    }

    const addonLoadedSetter = () => setAddonLoaded(true)
    document.addEventListener('ExtendBigcommerceAddonLoaded', addonLoadedSetter)

    return () => document.removeEventListener('ExtendBigcommerceAddonLoaded', addonLoadedSetter)
  }, [])

  useEffect(() => {
    if (!addonLoaded || !clientLoaded) {
      return
    }

    window.Extend.config({ storeId: EXTEND_ID, environment: EXTEND_ENVIRONMENT })

    setLoaded(true)
  }, [addonLoaded, clientLoaded])

  return loaded
}

export default useIsExtendScriptLoaded
